import { Box, Button, Typography } from '@mui/material'

export const ThankyouForRequest = () => {
  return (
    <Box display={'flex'} justifyContent={'center'} paddingTop={3}>
      <Box display={'grid'} textAlign={'center'}>
        <h2>
          この度はテラシテへお申し込みいただき、誠にありがとうございました。
        </h2>
        <Typography>
          お申込み内容を確認後、電力データを弊社が取得することに対する同意書を郵送いたします。
          <br />
          お手数ですが、電気のご契約者さまにご自署をいただいた上で、弊社までご返送お願いします。
        </Typography>
        <Box display={'flex'} justifyContent={'center'} paddingTop={3}>
          <Button href="https://www.terashite.jp/">
            テラシテトップのページへ戻る
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
